import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import { userTutorialTransport } from '@/data/userTutorial';
import type { UserTutorial } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010).
 *
 *  Its own root, not `auth`'s, although the field arrives on `GET user`: a
 *  tutorial write must not refetch the user (and everything that keys off
 *  it). This fetcher makes its own `GET user` and keeps only the tutorial. */
export const USER_TUTORIAL_ROOT = ['userTutorial'] as const;

interface UserTutorialParams {
    /** Names the old mock's storage key for the carry-over; the requests go by token. */
    userId: number;
}

const fetchers = {
    get: {
        key: ({ userId }: UserTutorialParams) => [...USER_TUTORIAL_ROOT, { userId }] as const,
        fetch: ({ userId }: UserTutorialParams): Promise<UserTutorial> => userTutorialTransport.get(userId),
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const userTutorialEntity: EntityDefinition<typeof fetchers> = {
    name: 'userTutorial',
    roots: [USER_TUTORIAL_ROOT],
    fetchers,
};

export const useUserTutorial = createEntityQuery(userTutorialEntity, 'get');

export type { UserTutorialParams };
